<div class="flex flex-col">
  <form [formGroup]="inputForm">
    <div *ngIf="subAccountPackages && subAccountPackages.length > 0" class="flex flex-row justify-start items-center">
      <mat-form-field appearance="outline" class="full-grow-no-shrink-no-basis">
        <mat-label>Packages</mat-label>
        <mat-select placeholder="Packages" formControlName="packages" multiple>
          <mat-option *ngFor="let subAccountPackage of subAccountPackages" [value]="subAccountPackage.code">
            {{subAccountPackage.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>
</div>
